import React from 'react';
import { Avatar, Link, Typography } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';
import Stack from '@mui/material/Stack';
import { filesize } from 'filesize';
import { Attachment } from 'modules/service-call/types';
import { useRecoilValue } from 'recoil';
import { tenantInfoState } from 'modules/application/atoms';

interface ServiceCallAttachmentPreviewProps {
  attachment: Attachment
  serviceCallId: string
  noteId: number
}

export const ServiceCallAttachmentPreview: React.FC<ServiceCallAttachmentPreviewProps> = ({ attachment, serviceCallId, noteId }) => {
  const tenantInfo = useRecoilValue(tenantInfoState);
  const isVideoFile = attachment.contentType.startsWith('video/');
  const attachmentSrc = `/${tenantInfo.identifier}/api/servicecalls/${serviceCallId}/notes/${noteId}/attachments/${attachment.id}`;

  return (
    <Stack direction='row' gap={2}>
      <Stack alignItems='center' justifyContent='center'>
        <Link href={attachmentSrc} target='_blank'>
          {isVideoFile ?
            <Avatar><VideocamIcon /></Avatar> :
            <img width={40} height={40} style={{objectFit:'cover'}} src={attachmentSrc} />
          }
        </Link>
      </Stack>
      <Stack>
        <Typography sx={{ wordWrap: 'break-word', overflowWrap: 'anywhere' }}>{attachment.fileName}</Typography>
        <Typography variant='caption' color='text.secondary'>{filesize(attachment.fileSize) as string}</Typography>
      </Stack>
    </Stack>
  );
};